<template>
  <div class="institution">
    <!-- 面包屑 -->
    <public-bread-crumb :routes="routes" />
    <!-- 顶部工具栏 -->
    <public-top-bar
      placeholder="请输入机构编号或名称"
      :showHighSearch="true"
      :topBarBtns="topBarBtns"
      :onTableSearchFun="onTableSearchFun"
      @changeBasicSearchFun="changeBasicSearchFun"
    >
      <template v-slot:highSearchGroup>
        <a-range-picker
          valueFormat="YYYY-MM-DD"
          :placeholder="['请选择创建开始日期', '请选择创建结束日期']"
          @change="onDateChange"
          style="width: 396px; margin-right: 20px"
        />
      </template>
    </public-top-bar>
    <!-- 页面Table -->
    <public-table
      :columns="columns"
      :tableData="tableData"
      :tableInfo="tableInfo"
      :operateA="operateA"
      :operateWidth="operateWidth"
      :tableLoading="tableLoading"
      @selectTableRowFun="selectTableRowFun"
    />
    <!-- 删除弹窗 -->
    <public-del
      ref="delWeight"
      delDesc="删除后，该机构下所有用户账号将不能登录系统，确认删除该条机构信息？"
      :btnLoading="btnLoading"
      :delTableDataFun="delTableDataFun"
    />
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @cancel="handleCancel"
      :width="modalWidth"
      centered
      class="institution-modal"
    >
      <div class="info" v-if="modalType === 'info'">
        <a-descriptions title="机构信息" :column="2">
          <a-descriptions-item label="机构编号">
            {{ infoData.number }}
          </a-descriptions-item>
          <a-descriptions-item label="机构名称">
            {{ infoData.name }}
          </a-descriptions-item>
          <a-descriptions-item label="所属区域">
            {{ infoData.address }}
          </a-descriptions-item>
          <a-descriptions-item label="详细地址">
            {{ infoData.detailedAddress }}
          </a-descriptions-item>
          <a-descriptions-item label="经纬度" span="2">
            {{ infoData.longitudeAndLatitude }}
          </a-descriptions-item>
          <a-descriptions-item label="备注">
            <a-tooltip>
              <template slot="title">
                {{ infoData.remark }}
              </template>
              <span class="remarks"> {{ infoData.remark }}</span>
            </a-tooltip>
          </a-descriptions-item>
        </a-descriptions>
        <p
          class="title"
          style="
          color: #5862cb;
            font-weight: bold;
            padding-bottom: 0.5em;
            margin-bottom: 0.5em;
            border-bottom: 1px solid #f5f5f5;
          "
        >
          机构信息
        </p>
        <div
          class="service-wrapper"
          style="
            display: flex;
            justify-content: space-between;
            width: 100%;
            padding-top: 5px;
          "
        >
          <p class="title" style="width: 20%">服务列表：</p>
          <div class="list" style="display: flex; width: 80%">
            <div class="item" v-for="item in infoData.list" :key="item.id">
              {{ item.name }}
            </div>
          </div>
        </div>
        <a-descriptions title="" :column="2">
          <a-descriptions-item label="管理员姓名">
            {{ infoData.manageName }}
          </a-descriptions-item>
          <a-descriptions-item label="管理员手机号">
            {{ infoData.managePhone }}
          </a-descriptions-item>
          <a-descriptions-item label="管理员账号">
            {{ infoData.manageAccount }}
          </a-descriptions-item>
          <a-descriptions-item label="运维账号">
            {{ infoData.account }}
          </a-descriptions-item>
          <a-descriptions-item label="运维密码">
            {{ infoData.password }}
          </a-descriptions-item>
          <!-- <a-descriptions-item label="创建人">
            {{ infoData.createName }}
          </a-descriptions-item> -->
          <a-descriptions-item label="创建时间">
            {{ infoData.time }}
          </a-descriptions-item>
        </a-descriptions>
      </div>
      <div
        class="text"
        v-else
        style="
          text-align: center;
          padding: 10px 0;
          font-size: 16px;
          color: #333;
        "
      >
        {{ modalText }}
      </div>
      <template slot="footer">
        <div class="footer" style="text-align: center">
          <a-button
            class="footer-btn"
            key="submit"
            type="primary"
            @click="handleOk"
            :loading="confirmLoading"
          >
            确认
          </a-button>
          <a-button
            class="footer-btn"
            key="back"
            style="background: #ecedff"
            @click="handleCancel"
          >
            取消
          </a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { publicTableList } from "@/mixins/mixinsData";
import institutionService from "@/services/institution.service";
export default {
  name: "Park",
  mixins: [publicTableList],
  data() {
    return {
      searchObj: {
        startTime: "",
        endTime: ""
      },
      visible: false,
      modalText: "",
      modalType: "",
      modalTitle: "",
      modalWidth: 446,
      confirmLoading: false,
      institutionId: "",
      infoData: {
        list: [],
        name: "",
        number: "",
        address: "",
        detailedAddress: "",
        contactName: "",
        contactPhone: "",
        remark: "",
        manageName: "",
        manageAccount: "",
        managePhone: "",
        account: "",
        password: "",
        createName: "",
        time: ""
      },
      serviceList: [
        { id: 0, name: "基础服务", selected: true },
        { id: 1, name: "门禁服务", selected: false },
        { id: 2, name: "监控服务", selected: false },
        { id: 3, name: "黑名单服务", selected: false },
        { id: 4, name: "场地预约服务", selected: false },
        { id: 5, name: "访客服务", selected: false },
        { id: 6, name: "考勤服务", selected: false },
        { id: 7, name: "消费服务", selected: false }
      ],
      routes: [
        {
          name: "机构管理",
          path: "/institution"
        }
      ],
      topBarBtns: [
        {
          name: "新增机构",
          type: "primary",
          fun: this.addInstitution
        }
      ],
      columns: [
        {
          title: "机构编号",
          dataIndex: "number",
          type: "tooltip",
          width: 120
        },
        {
          title: "机构名称",
          dataIndex: "name",
          type: "tooltip",
          width: 253
        },
        {
          title: "所属市区县",
          dataIndex: "address",
          type: "tooltip",
          width: 254
        },
        {
          title: "服务列表",
          dataIndex: "service",
          type: "tooltip",
          width: 420
        },
        {
          title: "创建日期",
          dataIndex: "time"
        }
      ],
      operateA: [
        {
          name: "查看",
          fun: this.handleLook
        },
        {
          name: "编辑",
          fun: this.handleEdit
        },
        {
          name: "删除",
          fun: this.rowDel
        },
        {
          name: "重置密码",
          fun: this.resetPassword
        }
      ],
      operateWidth: 240
    };
  },
  mounted() {},
  // 缓存组件激活
  activated() {
    // 获取园区列表
    this.getTableData(institutionService.getListByPage);
    // 获得删除接口
    this.tableServices.delServices = institutionService.delete;
  },
  // 缓存组件停用
  deactivated() {},
  methods: {
    onDateChange(v) {
      if (v) {
        this.searchObj.startTime = v[0];
        this.searchObj.endTime = v[1];
      } else {
        this.searchObj.startTime = "";
        this.searchObj.endTime = "";
      }
    },
    async handleOk() {
      this.confirmLoading = true;
      switch (this.modalType) {
        case "info":
          break;
        case "reset":
          const { status } = await institutionService.resetPassword({
            id: this.institutionId
          });
          if (status === 0) {
            this.$notification.success({
              title: "成功",
              description: "重置密码成功"
            });
          }
          break;
        default:
          console.log("error click");
      }
      this.confirmLoading = false;
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },
    // 查看
    handleLook({ id }) {
      this.visible = true;
      this.modalType = "info";
      this.modalTitle = "详情";
      this.getInfo(id);
    },
    // 获取查看详情
    async getInfo(id) {
      this.formLoading = true;
      const { status, result } = await institutionService.getInfo({
        id: id
      });
      this.formLoading = false;
      if (status === 0) {
        result.list = this.serviceList
          .map((item, index) => {
            if (index === 0) {
              return item;
            } else if (result.list && result.list.includes(item.id)) {
              return {
                id: item.id,
                name: item.name,
                selected: true
              };
            }
            return item;
          })
          .filter(v => v.selected);
      }
      this.infoData = result;
    },
    // 编辑
    handleEdit({ id }) {
      this.$router.push(`/institution/form?id=${id}`);
    },
    // 重置密码
    resetPassword({ id }) {
      this.institutionId = id;
      this.visible = true;
      this.modalType = "reset";
      this.modalTitle = "重置密码";
      this.modalText = "确认重置当前机构密码？";
    },
    // 新增机构
    addInstitution() {
      this.$router.push("/institution/form");
    },
    // 编辑?新增?
    addPageOrEditPage(item) {
      if (item && item.id) {
        this.$router.push(`/park/modify-form?id=${item.id}`);
      } else {
        this.$router.push("/park/modify-form");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.institution-modal {
  .footer {
    .footer-btn {
      width: 88px;
      height: 32px;
      margin-right: 32px;
      border-radius: 3px;
      border: 0px;
    }
  }
}
/deep/ .ant-descriptions-title {
  font-size: 14px;
  font-family: MicrosoftYaHeiSemibold;
  color: rgba(88, 98, 203, 1);
  line-height: 19px;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 5px;
  margin-bottom: 10px;
}
.service-wrapper {
  .title {
    color: rgba(0, 0, 0, 0.85);
  }
  .list {
    flex-wrap: wrap;
    .item {
      background: url("../../assets/institution/bg_serviceInfo.png") 0 0
        no-repeat;
      background-size: 100%;
      width: 116px;
      height: 40px;
      margin: 0 12px 12px 0;
      font-family: MicrosoftYaHeiSemibold;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      padding: 0 16px;
      cursor: pointer;
    }
  }
}

.remarks {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: 300px;
  vertical-align: -5px;
}
</style>
